import { labelClass } from "./styles";

const FieldGroup = ({ label, children }) => (
  <div>
    <label className={labelClass}>{label}</label>
    {children}
  </div>
);

export default FieldGroup;

